module.exports = "<h2>XDS Login Error</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/XdsLoginError/XdsLoginError.component.html
// module id = ./src/app/XdsLoginError/XdsLoginError.component.html
// module chunks = main